module.exports = __webpack_public_path__ + "static/media/thank-you-tracking-off.359d228c.svg";